
import {
  defineComponent,
  onBeforeMount,
  reactive,
  ref,
  watch,
} from 'vue';
import { Card, Modal } from 'ant-design-vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import SelecionarFiltroPeriodoMovimentoComercial from '@/components/Compartilhados/SelecionarFiltroPeriodoMovimentoComercial.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import SelecionarTipoOperacao from '@/components/Cadastros/SelecionarTipoOperacao.vue';
import SelecionarCliente from '@/components/Cadastros/Pessoas/Clientes/SelecionarCliente.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import SelecionarColaborador from '@/components/Cadastros/Pessoas/Colaboradores/SelecionarColaborador.vue';
import Icone from '@/core/components/Icone.vue';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import { IDTORelatorioVenda } from '@/models/Relatorios/Venda/IDTORelatorioVenda';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { IParametrosRelatorioVendas } from '@/models/ParametrosRequisicao/Vendas/IParametrosRelatorioVendas';
import { ECustomRenderRow, IColumn } from '@/core/models/AntDesign/IColumn';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import ServicoRelatoriosVendas from '@/servicos/Relatorios/ServicoRelatoriosVendas';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import SelecionarCamposRelatorioVendas from '@/components/Relatorios/Vendas/PainelVendas/SelecionarCamposRelatorioVendas.vue';
import SelecionarTipoRelatorioPainelVendas from '@/components/Relatorios/Vendas/PainelVendas/SelecionarTipoRelatorioPainelVendas.vue';
import CriacaoEdicaoLayoutModal from '@/components/Relatorios/Vendas/PainelVendas/CriacaoEdicaoLayoutModal.vue';
import { IDadosRelatorio, IDadosRelatorioCampo, IDadosRelatorioFiltros } from '@/models/Entidades/Relatorios/DadosRelatorio';
import SelecionarRelatorioPainelVendas from '@/components/Relatorios/Vendas/PainelVendas/SelecionarRelatorioPainelVendas.vue';
import ServicoDadosRelatorio from '@/servicos/Relatorios/ServicoDadosRelatorio';
import Totalizador from '@/core/components/Tela/Totalizador.vue';

export default defineComponent({
  name: 'PainelRelatorioVendasIndex',

  components: {
    TituloPadrao,
    Card,
    Icone,
    PreviewPdf,
    SelecionarFiltroPeriodoMovimentoComercial,
    SelecionarDataInicialFinal,
    SelecionarTipoRelatorioPainelVendas,
    SelecionarTipoOperacao,
    SelecionarCliente,
    SelecionarProduto,
    SelecionarColaborador,
    SelecionarCamposRelatorioVendas,
    SelecionarRelatorioPainelVendas,
    CriacaoEdicaoLayoutModal,
    Totalizador,
  },

  setup(props) {
    const dadosEmpresa = ref<IDTODadosEmpresa>({} as IDTODadosEmpresa);

    const {
      telaBase,
      preencherEmpresasDisponiveis,
      filtrarPermissaoDadosUsuarioMultiEmpresas,
      apresentarMensagemAlerta,
      apresentarMensagemErro,
      apresentarMensagemSucesso,
    } = useTelaBase();

    const { gradeBase, defineAlturaScrollDinamica } = useGradeBase();

    const servicoRelatorioVenda = new ServicoRelatoriosVendas();
    const permissaoServico = ref<boolean>(false);
    const servicoDadosRelatorio = new ServicoDadosRelatorio();
    const selectRelatorioRef = ref<any>(null);

    const state = reactive({
      identificadorRecurso: 'PAINEL_RELATORIO_VENDAS',
      tituloRecurso: 'Painel de Relatório de Vendas',
      carregandoTela: true,
      periodo: 1,
      dados: {} as IDTORelatorioVenda,
      dataInicialSelecionada: '',
      dataFinalSelecionada: '',
      filtroPeriodo: 0,
      dataAtual: '',
      empresaSelecionada: 0,
      colunas: [] as IColumn[],
      telaMobile: false,
      qtdSelecionados: 0,
      arquivoPdf: [] as IArquivoPdf[],
      tiposFiltro: [1] as number[],
      tipoAgrupador: 1,
      tipoOperacao: [] as number[],
      vendedores: [] as number[],
      clientes: [] as number[],
      produtos: [] as number[],
      camposRelatorio: '',
      parametros: {} as IParametrosRelatorioVendas,
      cacheAutomatico: {} as ISalvamentoAutomatico,
      descricao: '',
      mostrarConfiguracao: 1,
      dadosRelatorio: {} as IDadosRelatorio,
      dadosCadastro: {} as IDadosRelatorio,
      dadosRelatorioCampos: '',
      codigoRelatorio: 0,
      nomeRelatorio: '',
      modalConfiguracaoVisivel: false,
      modoEdicaoModal: false,
      tipoOperacaoModal: [] as number[],
      vendedoresModal: [] as number[],
      clientesModal: [] as number[],
      produtosModal: [] as number[],
    });

    function abrirModalConfiguracao() {
      state.modoEdicaoModal = false;
      state.dadosCadastro = {} as IDadosRelatorio;
      state.dadosRelatorioCampos = '';
      state.dadosCadastro.tiposFiltro = [1];
      state.dadosCadastro.agrupador = 1;
      state.dadosCadastro.filtros = [];
      state.tipoOperacaoModal = [];
      state.vendedoresModal = [];
      state.clientesModal = [];
      state.produtosModal = [];
      state.modalConfiguracaoVisivel = true;
    }

    function permitirMovimentacao(evt: any) {
      const item = evt.draggedContext.element;
      return item.key !== 'id';
    }

    function atualizarPosicoes() {
      state.colunas.forEach((col, i) => {
        // eslint-disable-next-line no-param-reassign
        col.position = i;
      });
    }

    const mapaCampos: Record<string, string> = {
      ValorTotal: 'valorTotal',
      ValorUnitario: 'valorUnitario',
      ValorDesconto: 'valorDesconto',
      ValorTotalProduto: 'valorTotalItem',
      Quantidade: 'quantidade',
      DataVenda: 'dataVenda',
      DataEmissao: 'dataEmissao',
      Produto: 'produto',
      Participacao: 'participacao',
      Cliente: 'cliente',
      CPFCNPJ: 'cpfcnpj',
      Cidade: 'cidade',
      UF: 'uf',
      Unidade: 'unidade',
      NumeroVenda: 'numeroVenda',
      NumeroNota: 'numeroNota',
      Vendedor: 'vendedor',
      FormaPagamento: 'formaPagamento',
      TipoOperacao: 'tipoOperacao',
    };

    const mapaTitulo: Record<string, string> = {
      ValorTotal: 'Valor Total',
      ValorUnitario: 'Valor Unitário',
      ValorDesconto: 'Valor Desconto',
      ValorTotalProduto: 'Valor Total Produto',
      Quantidade: 'Quantidade',
      DataVenda: 'Data Venda',
      DataEmissao: 'Data Emissão',
      Produto: 'Produto',
      Participacao: '% Part.',
      Cliente: 'Cliente',
      CPFCNPJ: 'CPF/CNPJ',
      Cidade: 'Cidade',
      UF: 'UF',
      Unidade: 'Unidade',
      NumeroVenda: 'Pedido',
      NumeroNota: 'NF-e',
      Vendedor: 'Vendedor',
      FormaPagamento: 'Forma de Pagamento',
      TipoOperacao: 'Tipo de Operação',
    };

    function obterCustomizacao(campo: string): number | undefined {
      switch (campo) {
        case 'DataVenda':
        case 'DataEmissao':
          return ECustomRenderRow.MascararData;

        case 'ValorTotal':
        case 'ValorUnitario':
        case 'ValorDesconto':
        case 'Quantidade':
        case 'ValorTotalProduto':
          return ECustomRenderRow.MascararFracionado;

        case 'CPFCNPJ':
          return ECustomRenderRow.MascararCPFCNPJ;

        case 'Participacao':
          return ECustomRenderRow.MascararPorcentagem;

        default:
          return ECustomRenderRow.HTMLPersonalizado;
      }
    }

    function montarColunas(campos: string) {
      const colunaId: IColumn = {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        position: 0,
        visible: false,
        ellipsis: false,
        ordering: false,
        width: 0,
        align: 'left',
      };

      if (!campos) {
        state.colunas = [colunaId];
        return;
      }

      const listaCampos = campos
        .split(',')
        .map((c) => c.trim())
        .filter((c) => c.length > 0);

      const colunasDinamicas = listaCampos.map((campo, i) => {
        const dataIndex = mapaCampos[campo];
        const customRender = obterCustomizacao(campo);

        return {
          title: mapaTitulo[campo],
          dataIndex,
          key: campo,
          position: i + 1,
          visible: true,
          ellipsis: true,
          ordering: true,
          align: 'left',
          customRenderRow: customRender,
          width: 160,
          minWidth: 80,
          maxWidth: 400,

          sorter: (a: any, b: any) => {
            const valA = a[dataIndex];
            const valB = b[dataIndex];

            if (
              customRender === ECustomRenderRow.MascararFracionado
          || customRender === ECustomRenderRow.MascararPorcentagem
            ) {
              return (valA || 0) - (valB || 0);
            }

            if (customRender === ECustomRenderRow.MascararData) {
              return new Date(valA).getTime() - new Date(valB).getTime();
            }

            return (valA || '').toString().localeCompare((valB || '').toString());
          },
        };
      });

      state.colunas = [colunaId, ...colunasDinamicas];
    }

    function iniciarResizeColuna(
      event: MouseEvent,
      coluna: IColumn,
    ) {
      event.preventDefault();

      const startX = event.clientX;
      const startWidth = coluna.width || 160;

      const onMouseMove = (e: MouseEvent) => {
        const novaLargura = startWidth + (e.clientX - startX);

        const min = coluna.minWidth ?? 80;
        const max = coluna.maxWidth ?? 600;

        // eslint-disable-next-line no-param-reassign
        coluna.width = Math.min(Math.max(novaLargura, min), max);
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }

    function prencheDatasPeriodo() {
      // eslint-disable-next-line default-case
      switch (state.periodo) {
        case EFiltroPeriodoMovimentoComercial.Hoje:
          state.dataInicialSelecionada = state.dataAtual;
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ontem:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          state.dataFinalSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          break;

        case EFiltroPeriodoMovimentoComercial.SemanaAtual:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 7);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.MesAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaMes(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaMes(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.AnoAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaAno(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaAno(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos15Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 15);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos30Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 30);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos60Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 60);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos90dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 90);
          state.dataFinalSelecionada = state.dataAtual;
          break;
      }
    }

    function validarConsistenciaCampos(tipo: number, camposString: string, agrupador: number): string | null {
      if (!camposString) return null;

      const listaCampos = camposString.split(',').map((c) => c.trim());
      console.log('listaCampos: ', listaCampos);

      // Ajuste os números (cases) conforme o seu Enum "ETipoRelatorioVendas"
      // eslint-disable-next-line default-case
      switch (tipo) {
        case 1:
          // eslint-disable-next-line default-case
          switch (agrupador) {
            case 1:
              break;
            case 2:
              if (!listaCampos.includes('Vendedor')) {
                return 'O campo "Vendedor" deve estar selecionado para agrupar por vendedor';
              }
              break;
            case 4: // Produto
              if (!listaCampos.includes('Produto')) {
                return 'O campo "Produto" deve estar selecionado para agrupar por produto';
              }
              break;
            case 3: // Cliente
              if (!listaCampos.includes('Cliente')) {
                return 'O campo "Cliente" deve estar selecionado para agrupar por cliente';
              }
              break;
            case 5: // Cliente
              if (!listaCampos.includes('Cidade')) {
                return 'O campo "Cidade" deve estar selecionado para agrupar por cidade';
              }
              break;
          }
          break;
        case 4: // Produto
          if (!listaCampos.includes('Produto')) {
            return 'Para o tipo de relatório "Produto", o campo "Produto" deve estar selecionado.';
          }
          break;
        case 3: // Cliente
          if (!listaCampos.includes('Cliente')) {
            return 'Para o tipo de relatório "Cliente", o campo "Cliente" deve estar selecionado.';
          }
          break;
        case 2: // Vendedor
          if (!listaCampos.includes('Vendedor')) {
            return 'Para o tipo de relatório "Vendedor", o campo "Vendedor" deve estar selecionado.';
          }
          break;
        // Adicione outros casos se necessário
      }

      return null; // Retorna null se estiver tudo válido
    }

    async function buscarRelatorio() {
      if (state.camposRelatorio.trim() === '') {
        return;
      }

      // const erroConsistencia = validarConsistenciaCampos(state.tiposFiltro[0], state.camposRelatorio, state.tipoAgrupador);
      // if (erroConsistencia) {
      //  apresentarMensagemAlerta(erroConsistencia);
      //  return;
      // }
      prencheDatasPeriodo();
      const parametrosConsulta = {} as IParametrosRelatorioVendas;

      parametrosConsulta.empresa = state.empresaSelecionada;
      parametrosConsulta.ordenacao = [];
      parametrosConsulta.periodo = state.periodo;
      parametrosConsulta.dataInicial = state.dataInicialSelecionada;
      parametrosConsulta.dataFinal = state.dataFinalSelecionada;
      parametrosConsulta.ordenacao.push('Status', 'DataEmissao|DESC');

      parametrosConsulta.tipoOperacao = state.tipoOperacao;
      parametrosConsulta.clientes = state.clientes;
      parametrosConsulta.vendedores = state.vendedores;
      parametrosConsulta.produtos = state.produtos;

      parametrosConsulta.tiposFiltro = state.tiposFiltro;
      parametrosConsulta.tipoAgrupador = state.tipoAgrupador;

      parametrosConsulta.qtdeRegistrosPagina = 1000;

      parametrosConsulta.camposRelatorio = state.camposRelatorio
        .split(',')
        .map((c) => c.trim())
        .filter((c) => c.length > 0);

      telaBase.carregando = true;
      state.parametros = parametrosConsulta;
      const listaPaginada = await servicoRelatorioVenda.obterRelatorioVendas(parametrosConsulta);
      console.log('listaPaginada: ', listaPaginada);
      state.dados = listaPaginada;
      telaBase.carregando = false;
    }

    async function imprimir(tipoArquivoRelatorio: ETipoArquivo) {
      telaBase.carregando = true;

      const camposValidos = (Array.isArray(state.tiposFiltro) ? state.tiposFiltro : []).every((tipo) => {
        const erroConsistencia = validarConsistenciaCampos(tipo, state.camposRelatorio, state.tipoAgrupador);
        if (erroConsistencia) {
          apresentarMensagemAlerta(erroConsistencia);
          return false;
        }
        return true;
      });

      if (!camposValidos) {
        telaBase.carregando = false;
        return;
      }

      if (!UtilitarioGeral.validaLista(state.dados.itens)) {
        await buscarRelatorio();
      }

      const retornoRelatorio = await servicoRelatorioVenda.obterArquivRelatoriooVenda(
        tipoArquivoRelatorio,
        state.parametros,
      );

      telaBase.carregando = false;

      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{
            nome: '',
            link: retornoRelatorio.link,
          }];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [dadosEmpresa.value.codigoEmpresa];
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(
        telaBase.empresasSelecionadas,
      );

      permissaoServico.value = await new ServicoSistema()
        .validarPermissaoModulo(dadosEmpresa.value.codigoEmpresa, 8);
    }

    const filtros = ref({ data: null, tipo: null, status: null });

    async function periodoAlterado() {
      if (state.filtroPeriodo !== EFiltroPeriodoMovimentoComercial.Personalizado) {
        await buscarRelatorio();
      }
    }

    async function obterDadosRelatorio() {
      state.camposRelatorio = '';
      state.tipoOperacao = [];
      state.vendedores = [];
      state.clientes = [];
      state.produtos = [];

      console.log('Carregando relatório:', { codigoRelatorio: state.codigoRelatorio, empresa: state.empresaSelecionada });

      state.dadosRelatorio = await servicoDadosRelatorio.obter(state.codigoRelatorio, state.empresaSelecionada);

      console.log('Dados do relatório carregados:', state.dadosRelatorio);

      if (UtilitarioGeral.objetoValido(state.dadosRelatorio)) {
        state.camposRelatorio = state.dadosRelatorio.campos.map((c) => c.campo).join(', ');
        state.tipoAgrupador = state.dadosRelatorio.agrupador;
        state.nomeRelatorio = state.dadosRelatorio.descricao;

        // Preencher os filtros selecionados na tela principal
        if (state.dadosRelatorio.filtros && Array.isArray(state.dadosRelatorio.filtros)) {
          console.log('Processando filtros:', state.dadosRelatorio.filtros);

          // Extrair tipos de filtro baseado nos filtros salvos
          const tiposDeFilteroSalvos: number[] = [];

          state.dadosRelatorio.filtros.forEach((filtro) => {
            const valores = filtro.filtrosSelecionados.split(',').map((v: string) => parseInt(v, 10));
            const tipoFiltroStr = String(filtro.tipoFiltro);
            console.log(`Aplicando filtro ${tipoFiltroStr}:`, valores);

            // Determinar o tipo de filtro e adicionar ao array de tipos
            if (tipoFiltroStr === 'TipoOperacao') {
              state.tipoOperacao = valores;
              if (!tiposDeFilteroSalvos.includes(1)) tiposDeFilteroSalvos.push(1);
            } else if (tipoFiltroStr === 'Vendedor') {
              state.vendedores = valores;
              if (!tiposDeFilteroSalvos.includes(2)) tiposDeFilteroSalvos.push(2);
            } else if (tipoFiltroStr === 'Cliente') {
              state.clientes = valores;
              if (!tiposDeFilteroSalvos.includes(3)) tiposDeFilteroSalvos.push(3);
            } else if (tipoFiltroStr === 'Produto') {
              state.produtos = valores;
              if (!tiposDeFilteroSalvos.includes(4)) tiposDeFilteroSalvos.push(4);
            }
          });

          // Definir tiposFiltro baseado nos filtros salvos
          state.tiposFiltro = tiposDeFilteroSalvos;
          console.log('Tipos de filtro extraídos dos filtros salvos:', state.tiposFiltro);
        } else {
          // Se não há filtros salvos, manter o tiposFiltro vazio
          state.tiposFiltro = [];
        }
      }
      state.dados = {} as IDTORelatorioVenda;
    }

    async function excluir(codigoRelatorio?: number) {
      const codigoParaExcluir = codigoRelatorio || state.dadosRelatorio.codigo;
      if (!codigoParaExcluir) {
        apresentarMensagemAlerta('Nenhum relatório selecionado para exclusão.');
        return;
      }

      Modal.confirm({
        title: 'Você realmente deseja excluir o Relatório Selecionado?',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoDadosRelatorio.excluir(codigoParaExcluir);
          if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
            apresentarMensagemSucesso(retorno.mensagem);
            if (selectRelatorioRef.value) {
              selectRelatorioRef.value.recarregarDados();
            }
            // Limpa a seleção se o relatório excluído era o que estava ativo
            if (state.codigoRelatorio === codigoParaExcluir) {
              state.codigoRelatorio = 0;
              state.nomeRelatorio = '';
              state.camposRelatorio = '';
              state.tiposFiltro = [1];
              state.dados = {} as IDTORelatorioVenda;
            }
          } else {
            apresentarMensagemErro(retorno.mensagem);
          }
        },
      });
    }

    async function ValidarCampos(campos: IDadosRelatorioCampo[]) {
      if (campos.length === 0) {
        apresentarMensagemAlerta('É necessário adicionar os campos');
        return false;
      }
      return true;
    }

    async function converterCamposRelatorio(valor: string, codigoRelatorio: number): Promise<IDadosRelatorioCampo[]> {
      if (!valor) return [];

      return valor.split(',').map((c) => c.trim()).filter(Boolean).map((campo, index) => ({
        codigo: 0,
        codigoRelatorio,
        campo,
        ordem: index + 1,
      }));
    }

    async function handleSalvarLayout(dados: {
      dadosCadastro: IDadosRelatorio;
      dadosRelatorioCampos: string;
      tipoOperacaoModal: number[];
      vendedoresModal: number[];
      clientesModal: number[];
      produtosModal: number[];
    }) {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      const campos = await converterCamposRelatorio(
        dados.dadosRelatorioCampos,
        dados.dadosCadastro.codigo,
      );

      if (!await ValidarCampos(campos)) { return; }

      const dadosParaSalvar = { ...dados.dadosCadastro };
      dadosParaSalvar.campos = campos;

      // Preencher filtros baseado nos tipos de filtro selecionados
      const filtros: IDadosRelatorioFiltros[] = [];

      if (Array.isArray(dados.dadosCadastro.tiposFiltro)) {
        // Filtro de Tipo de Operação
        if (dados.dadosCadastro.tiposFiltro.includes(1) && dados.tipoOperacaoModal.length > 0) {
          filtros.push({
            codigo: 0,
            codigoRelatorio: dados.dadosCadastro.codigo || 0,
            tipoFiltro: 'TipoOperacao',
            filtrosSelecionados: dados.tipoOperacaoModal.join(','),
          });
        }

        // Filtro de Vendedor
        if (dados.dadosCadastro.tiposFiltro.includes(2) && dados.vendedoresModal.length > 0) {
          filtros.push({
            codigo: 0,
            codigoRelatorio: dados.dadosCadastro.codigo || 0,
            tipoFiltro: 'Vendedor',
            filtrosSelecionados: dados.vendedoresModal.join(','),
          });
        }

        // Filtro de Cliente
        if (dados.dadosCadastro.tiposFiltro.includes(3) && dados.clientesModal.length > 0) {
          filtros.push({
            codigo: 0,
            codigoRelatorio: dados.dadosCadastro.codigo || 0,
            tipoFiltro: 'Cliente',
            filtrosSelecionados: dados.clientesModal.join(','),
          });
        }

        // Filtro de Produto
        if (dados.dadosCadastro.tiposFiltro.includes(4) && dados.produtosModal.length > 0) {
          filtros.push({
            codigo: 0,
            codigoRelatorio: dados.dadosCadastro.codigo || 0,
            tipoFiltro: 'Produto',
            filtrosSelecionados: dados.produtosModal.join(','),
          });
        }
      }

      dadosParaSalvar.filtros = filtros;
      dadosParaSalvar.tiposFiltro = dados.dadosCadastro.tiposFiltro;

      console.log('Salvando layout com tiposFiltro:', dadosParaSalvar.tiposFiltro);
      console.log('Salvando filtros:', filtros);

      // Atualizar o state com os dados do modal
      state.dadosCadastro = dados.dadosCadastro;
      state.dadosRelatorioCampos = dados.dadosRelatorioCampos;
      state.tipoOperacaoModal = dados.tipoOperacaoModal;
      state.vendedoresModal = dados.vendedoresModal;
      state.clientesModal = dados.clientesModal;
      state.produtosModal = dados.produtosModal;

      if (state.modoEdicaoModal) {
        retorno = await servicoDadosRelatorio.alterar(dadosParaSalvar);
      } else {
        dadosParaSalvar.codigo = 0;
        dadosParaSalvar.codigoEmpresa = state.empresaSelecionada;
        dadosParaSalvar.modulo = 7;
        retorno = await servicoDadosRelatorio.incluir(dadosParaSalvar);
      }

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        state.modalConfiguracaoVisivel = false;
        if (selectRelatorioRef.value) {
          selectRelatorioRef.value.recarregarDados();
        }
        // Se estava editando, força a recarga dos dados na tela principal
        if (state.modoEdicaoModal && state.codigoRelatorio === dadosParaSalvar.codigo) {
          await obterDadosRelatorio();
        }
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
    }

    async function handleEditReport(report: { codigo: number }) {
      // Garante que o modal seja configurado para edição desde o início
      state.modoEdicaoModal = true;
      state.dadosCadastro = {} as IDadosRelatorio;
      state.dadosRelatorioCampos = '';
      state.tipoOperacaoModal = [];
      state.vendedoresModal = [];
      state.clientesModal = [];
      state.produtosModal = [];

      const dadosRelatorio = await servicoDadosRelatorio.obter(report.codigo, state.empresaSelecionada);
      if (dadosRelatorio) {
        state.dadosCadastro = { ...dadosRelatorio };
        // Garantir que tiposFiltro é um array de números
        if (state.dadosCadastro.tiposFiltro) {
          state.dadosCadastro.tiposFiltro = state.dadosCadastro.tiposFiltro.map((t: any) => (typeof t === 'string' ? parseInt(t, 10) : t));
        }
        state.dadosRelatorioCampos = dadosRelatorio.campos.map((c) => c.campo).join(', ');

        // Preencher os filtros do modal baseado nos filtros salvos
        if (dadosRelatorio.filtros && Array.isArray(dadosRelatorio.filtros)) {
          dadosRelatorio.filtros.forEach((filtro) => {
            const valores = filtro.filtrosSelecionados.split(',').map((v: string) => parseInt(v, 10));
            const tipoFiltroStr = String(filtro.tipoFiltro);
            if (tipoFiltroStr === 'TipoOperacao') {
              state.tipoOperacaoModal = valores;
            } else if (tipoFiltroStr === 'Vendedor') {
              state.vendedoresModal = valores;
            } else if (tipoFiltroStr === 'Cliente') {
              state.clientesModal = valores;
            } else if (tipoFiltroStr === 'Produto') {
              state.produtosModal = valores;
            }
          });
        }

        state.modalConfiguracaoVisivel = true;
      } else {
        apresentarMensagemErro('Não foi possível carregar os dados do relatório para edição.');
        // Reseta o modo de edição se os dados não puderem ser carregados
        state.modoEdicaoModal = false;
      }
    }

    function handleDeleteReport(report: { codigo: number }) {
      excluir(report.codigo);
    }

    watch(
      () => state.modalConfiguracaoVisivel,
      (novoValor) => {
        if (novoValor && state.modoEdicaoModal) {
          // Modal foi aberto para edição, os dados já devem estar em state
          console.log('Modal aberto para edição com dados:', state.dadosCadastro);
        }
      },
    );

    watch(
      () => state.camposRelatorio,
      (novoValor) => {
        montarColunas(novoValor);
      },
      { immediate: true },
    );

    watch(
      () => state.tiposFiltro,
      (novosTipos, tiposAntigos) => {
        if (tiposAntigos && !novosTipos.includes(1) && tiposAntigos.includes(1)) {
          state.tipoOperacao = [];
        }
        if (tiposAntigos && !novosTipos.includes(2) && tiposAntigos.includes(2)) {
          state.vendedores = [];
        }
        if (tiposAntigos && !novosTipos.includes(3) && tiposAntigos.includes(3)) {
          state.clientes = [];
        }
        if (tiposAntigos && !novosTipos.includes(4) && tiposAntigos.includes(4)) {
          state.produtos = [];
        }
      },
      { deep: true },
    );

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      telaBase.identificadorRecurso = state.identificadorRecurso;
      state.codigoRelatorio = await servicoDadosRelatorio.obterCodigo(state.empresaSelecionada, 7);

      // Inicializar o estado do relatório padrão
      state.dadosCadastro.codigo = 0;
      state.dadosCadastro.codigoEmpresa = state.empresaSelecionada;
      state.dadosCadastro.tiposFiltro = [1];
      state.dadosCadastro.agrupador = 1;
      state.dadosCadastro.modulo = 7;

      if (state.codigoRelatorio > 0) {
        await obterDadosRelatorio();
        state.mostrarConfiguracao = 2;
      } else {
        state.mostrarConfiguracao = 1;
      }

      await preencherEmpresasDisponiveis();
      state.dataAtual = await new ServicoSistema().obterDataAtual();

      const dadosEmpresaCache = storeSistema.state.empresasDisponiveis
        .find((c) => c.codigoEmpresa === state.empresaSelecionada);
      if (dadosEmpresaCache) dadosEmpresa.value = dadosEmpresaCache;
    });
    return {
      props,
      filtros,
      state,
      dadosEmpresa,
      telaBase,
      gradeBase,
      buscarRelatorio,
      atualizarSelecaoEmpresas,
      periodoAlterado,
      atualizarPosicoes,
      permitirMovimentacao,
      UtilitarioMascara,
      UtilitarioData,
      ECustomRenderRow,
      EFiltroPeriodoMovimentoComercial,
      imprimir,
      ETipoArquivo,
      window,
      defineAlturaScrollDinamica,
      handleSalvarLayout,
      obterDadosRelatorio,
      excluir,
      selectRelatorioRef,
      iniciarResizeColuna,
      abrirModalConfiguracao,
      handleEditReport,
      handleDeleteReport,
    };
  },
});
